import { deleteProductImage, fetchProductImage, postProductImage } from '@/api/productImage.api';
import type { EProductFileField } from '@/domain/product/EProductFileField';
import type { EProductImageType } from '@/domain/product/EProductImageType';
import type { IProductImageRepository } from '@/application/ports/IProductImageRepository';

// HTTP adapter for IProductImageRepository.
class HttpProductImageRepository implements IProductImageRepository {
    add(file: File, productId: string, type: EProductImageType): Promise<string> {
        return postProductImage(file, productId, type);
    }

    get(uuid: string): Promise<Blob> {
        return fetchProductImage(uuid);
    }

    remove(productName: string, field: EProductFileField): Promise<void> {
        return deleteProductImage(productName, field);
    }
}

export { HttpProductImageRepository };
